// Event data for APN
// Past events from the APN website
export const pastEvents = [
  {
    id: 101,
    title: 'APN CHICAGO IS BACK!',
    image: '/images/events/chicago-event-2023.png',
    date: 'November 14, 2023',
    time: '5:30 PM - 7:30 PM CST',
    location: 'District Brew Yards in West Town, Chicago',
    address: '417 N Ashland Ave, Chicago, IL 60622',
    price: '$100.00 - $150.00',
    featured: true,
    description: 'Join us for our Chicago networking event at District Brew Yards! Connect with finance professionals from across the industry and expand your network in a relaxed and engaging environment.',
    longDescription: `
      <p>APN CHICAGO IS BACK! Join us for an evening of networking, connections, and opportunities at District Brew Yards in West Town.</p>

      <p>This exclusive event brings together finance professionals from across Chicago's vibrant financial sector. Whether you're in investment banking, private equity, wealth management, or any other finance specialty, this is your chance to expand your network and forge valuable connections.</p>

      <p>The evening will include:</p>
      <ul>
        <li>Networking with finance professionals across all levels</li>
        <li>Complimentary appetizers and drinks</li>
        <li>Brief remarks from industry leaders</li>
        <li>Opportunities to connect with potential mentors and collaborators</li>
      </ul>

      <p>Don't miss this opportunity to be part of Chicago's premier finance networking community!</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2023/10/APN-Chicago-Event.png'
  },
  {
    id: 102,
    title: 'APN NY IS BACK!',
    image: '/images/events/ny-event-2023.png',
    date: 'November 7, 2023',
    time: '6:30 PM - 8:30 PM EST',
    location: 'Printers Alley, New York',
    address: '215 W 40th Street, New York, NY 10018',
    price: '$100.00 - $150.00',
    featured: true,
    description: 'Join us for our New York networking event at Printers Alley! Connect with finance professionals from across the industry and expand your network in a relaxed and engaging environment.',
    longDescription: `
      <p>APN NY IS BACK! Join us for an evening of networking, connections, and opportunities at Printers Alley in the heart of Manhattan.</p>

      <p>This exclusive event brings together finance professionals from across New York's vibrant financial sector. Whether you're in investment banking, private equity, wealth management, or any other finance specialty, this is your chance to expand your network and forge valuable connections.</p>

      <p>The evening will include:</p>
      <ul>
        <li>Networking with finance professionals across all levels</li>
        <li>Complimentary appetizers and drinks</li>
        <li>Brief remarks from industry leaders</li>
        <li>Opportunities to connect with potential mentors and collaborators</li>
      </ul>

      <p>Don't miss this opportunity to be part of New York's premier finance networking community!</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2023/10/APN-NY-Event_new.png'
  },
  {
    id: 103,
    title: 'APN One Year Celebration',
    image: '/images/events/one-year-celebration.jpg',
    date: 'May 23, 2023',
    time: '6:00 PM - 8:00 PM EST',
    location: 'Printers Alley, New York',
    address: '215 W 40th Street, New York, NY 10018',
    price: '$5.00 - $125.00',
    featured: true,
    description: 'Please join us for Accelerated Professional Networks\' one year anniversary event at Printers Alley! All are welcome, including non-members. Come enjoy drinks and great conversation as we continue to build out our professional networks.',
    longDescription: `
      <p>Please join us for Accelerated Professional Networks' one year anniversary event at Printers Alley! All are welcome, including non-members. Come enjoy drinks and great conversation as we continue to build out our professional networks. Hope to see you there!</p>

      <p>By registering for this event you agree to our terms and conditions.</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2023/05/APN-Printers-Alley-May-23rd.jpg'
  },
  {
    id: 104,
    title: 'APN\'s First Annual Holiday Event!',
    image: '/images/events/holiday-event-2022.jpg',
    date: 'December 13, 2022',
    time: '6:30 PM - 8:30 PM EST',
    location: 'VERSA Canopy, New York',
    address: '218 W 35th St, New York, NY 10001',
    price: '$24.00 - $200.00',
    featured: false,
    description: 'Join APN for our first annual Holiday Party at VERSA Canopy! Private Equity gets in free (email for discount code). Come join us to celebrate our first year as APN, a year of successful dealmaking, and make new connections!',
    longDescription: `
      <p>Join APN for our first annual Holiday Party at VERSA Canopy on Tuesday, December 13th from 6:30-8:30! Private Equity gets in free (email cburnham@the-apn.com for discount code). Come join us to celebrate our first year as APN, a year of successful dealmaking, and make new connections! We hope to see you there!</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2022/11/FINAL-HOLIDAY-GRAPHIC.jpg'
  },
  {
    id: 105,
    title: 'Fall Kickoff Event!',
    image: '/images/events/fall-kickoff-2022.png',
    date: 'October 11, 2022',
    time: '6:30 PM - 8:30 PM EDT',
    location: 'Clinton Hall, New York',
    address: '16 W 36th St, New York, NY 10018',
    price: '$24.00 - $125.00',
    featured: false,
    description: 'Come join APN for our Fall Kickoff event at Clinton Hall on W. 36th Street to network with likeminded junior M&A professionals!',
    longDescription: `
      <p>Come join APN for our Fall Kickoff event at Clinton Hall on W. 36th Street Tuesday, October 11th from 6:30-8:30 to network with likeminded junior M&A professionals! Hope to see you there!</p>

      <p>Accelerated Professionals Network is a community of finance professionals collaborating to create a more seamless M&A transaction process. Catering to junior professionals (non-partners), APN encourages those in the financial industry to begin building their networks early in their careers resulting in more transparency into the full life cycle of a deal, an increase in the potential for expedited career growth and development, and greater access to resources as they continue to advance within their roles/organizations.</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2022/09/APN-Clinton-Hal.png'
  },
  {
    id: 106,
    title: 'APN End of Summer Bash!',
    image: '/images/events/summer-bash-2022.jpeg',
    date: 'August 9, 2022',
    time: '6:30 PM - 8:30 PM',
    location: 'The Perfect Pint, New York',
    address: '203 E 45th St, New York, NY 10017',
    price: '$24.00 - $175.00',
    featured: false,
    description: 'Please join us for the Accelerated Professionals Network\'s End of Summer Bash IN PERSON once again at the Perfect Pint!',
    longDescription: `
      <p>Please join us for the Accelerated Professionals Network's End of Summer Bash IN PERSON once again at the Perfect Pint! All are welcome, including non-members. Come enjoy drinks, food, great conversation and warm weather as we continue to build out our networks and create a more seamless M&A deal cycle!</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2022/04/the-perfect-pint-midtown-east.jpeg'
  },
  {
    id: 107,
    title: 'APN Launch',
    image: '/images/events/apn-launch-2022.jpg',
    date: 'April 26, 2022',
    time: '6:30 PM - 8:30 PM',
    location: 'Printers Alley, New York',
    address: '215 W 40th Street, New York, NY 10018',
    price: '$5.00 - $125.00',
    featured: false,
    description: 'Please join us for Accelerated Professional Networks\' first IN PERSON event at Printers Alley!',
    longDescription: `
      <p>Please join us for Accelerated Professional Networks' first IN PERSON event at Printers Alley! All are welcome, including non-members. Come enjoy drinks and great conversation as we continue to build out our networks. Hope to see you there!</p>

      <p>By registering for this event you agree to our terms and conditions.</p>
    `,
    eventType: 'in-person',
    isPast: true,
    originalImageUrl: 'https://the-apn.com/wp-content/uploads/2022/04/events.jpg'
  },
  {
    id: 108,
    title: 'Bi Monthly National Networking Group - May 2022',
    image: '/images/events/virtual-networking-event-logo.jpeg',
    date: 'May 17, 2022',
    time: '6:00 PM - 7:00 PM EDT',
    location: 'Virtual Event',
    address: 'Online',
    price: 'Free',
    featured: false,
    description: 'Join us for our bi-monthly virtual networking event to connect with professionals across the country!',
    longDescription: `
      <p>Join us for our bi-monthly virtual networking event to connect with professionals across the country! This is a great opportunity to expand your network beyond your local area and connect with like-minded professionals in the M&A space.</p>

      <p>This event is free for all members and non-members. We hope to see you there!</p>
    `,
    eventType: 'virtual',
    isPast: true,
    originalImageUrl: '/apn-logos/virtual-networking-event-logo-photo.jpeg'
  },
  {
    id: 109,
    title: 'Bi Monthly National Networking Group - July 2022',
    image: '/images/events/virtual-networking-event-logo.jpeg',
    date: 'July 19, 2022',
    time: '6:00 PM - 7:00 PM EDT',
    location: 'Virtual Event',
    address: 'Online',
    price: 'Free',
    featured: false,
    description: 'Join us for our bi-monthly virtual networking event to connect with professionals across the country!',
    longDescription: `
      <p>Join us for our bi-monthly virtual networking event to connect with professionals across the country! This is a great opportunity to expand your network beyond your local area and connect with like-minded professionals in the M&A space.</p>

      <p>This event is free for all members and non-members. We hope to see you there!</p>
    `,
    eventType: 'virtual',
    isPast: true,
    originalImageUrl: '/apn-logos/virtual-networking-event-logo-photo.jpeg'
  },
  {
    id: 110,
    title: 'Bi Monthly National Networking Group - September 2022',
    image: '/images/events/virtual-networking-event-logo.jpeg',
    date: 'September 20, 2022',
    time: '6:00 PM - 7:00 PM EDT',
    location: 'Virtual Event',
    address: 'Online',
    price: 'Free',
    featured: false,
    description: 'Join us for our bi-monthly virtual networking event to connect with professionals across the country!',
    longDescription: `
      <p>Join us for our bi-monthly virtual networking event to connect with professionals across the country! This is a great opportunity to expand your network beyond your local area and connect with like-minded professionals in the M&A space.</p>

      <p>This event is free for all members and non-members. We hope to see you there!</p>
    `,
    eventType: 'virtual',
    isPast: true,
    originalImageUrl: '/apn-logos/virtual-networking-event-logo-photo.jpeg'
  },
  {
    id: 111,
    title: 'Bi Monthly National Networking Group - November 2022',
    image: '/images/events/virtual-networking-event-logo.jpeg',
    date: 'November 15, 2022',
    time: '6:00 PM - 7:00 PM EST',
    location: 'Virtual Event',
    address: 'Online',
    price: 'Free',
    featured: false,
    description: 'Join us for our bi-monthly virtual networking event to connect with professionals across the country!',
    longDescription: `
      <p>Join us for our bi-monthly virtual networking event to connect with professionals across the country! This is a great opportunity to expand your network beyond your local area and connect with like-minded professionals in the M&A space.</p>

      <p>This event is free for all members and non-members. We hope to see you there!</p>
    `,
    eventType: 'virtual',
    isPast: true,
    originalImageUrl: '/apn-logos/virtual-networking-event-logo-photo.jpeg'
  },
  // Recently past events from 2025
  {
    id: 112,
    title: 'Excel Mastery for Finance Professionals',
    image: '/images/events/event-placeholder.png',
    date: 'January 25, 2025',
    time: '2:00 PM - 4:00 PM',
    location: 'Virtual Workshop (Zoom)',
    address: 'Online',
    price: '$25.00 - $40.00',
    featured: true,
    description: 'Master advanced Excel techniques specifically designed for finance professionals. Learn financial modeling, data analysis, and automation.',
    eventType: 'virtual',
    category: 'education',
    virtualPlatform: 'Zoom',
    isPast: true
  },
  {
    id: 113,
    title: 'Financial Modeling Fundamentals',
    image: '/images/events/event-placeholder.png',
    date: 'February 15, 2025',
    time: '1:00 PM - 5:00 PM',
    location: 'Virtual Workshop (Microsoft Teams)',
    address: 'Online',
    price: '$75.00 - $100.00',
    featured: true,
    description: 'Learn the fundamentals of financial modeling from industry experts. Build DCF models, comparable analysis, and more.',
    eventType: 'virtual',
    category: 'education',
    virtualPlatform: 'Microsoft Teams',
    isPast: true
  },
  {
    id: 114,
    title: 'APN CHICAGO IS BACK!',
    image: '/images/events/event-placeholder.png',
    date: 'May 15, 2025',
    time: '6:00 PM - 9:00 PM',
    location: 'District Brew Yards in West Town, Chicago',
    address: '417 N Ashland Ave, Chicago, IL 60622',
    price: '$100.00 - $150.00',
    featured: true,
    description: 'Join us for our Chicago networking event at District Brew Yards! Connect with finance professionals from across the industry and expand your network in a relaxed and engaging environment.',
    eventType: 'in-person',
    isPast: true
  },
  {
    id: 115,
    title: 'APN NY IS BACK!',
    image: '/images/events/event-placeholder.png',
    date: 'June 10, 2025',
    time: '7:00 PM - 10:00 PM',
    location: 'Printers Alley, New York',
    address: '215 W 40th St, New York, NY 10018',
    price: '$100.00 - $150.00',
    featured: true,
    description: 'Join us for our New York networking event at Printers Alley! Connect with finance professionals from across the industry and expand your network.',
    eventType: 'in-person',
    isPast: true
  }
];

// Upcoming events for 2025-2026
export const events = [
  {
    id: 6,
    title: 'APN Virtual Investment Strategies Summit',
    image: '/images/events/event-placeholder.png',
    date: 'November 4, 2025',
    time: '1:00 PM - 3:30 PM',
    location: 'Virtual Event (Microsoft Teams)',
    address: 'Online',
    price: '$50.00 - $75.00',
    featured: false,
    description: 'Join us for our virtual investment strategies summit featuring expert panels and networking opportunities. Learn about the latest investment trends and strategies from industry leaders.',
    comments: [
      {
        id: 1,
        userId: 7,
        userName: 'Robert Kim',
        userImage: '/images/profiles/robert-kim.jpg',
        userTitle: 'Investment Analyst',
        userCompany: 'Fidelity Investments',
        text: 'Will the sessions be recorded for those who can\'t attend the entire event?',
        timestamp: '2025-10-20T13:15:00Z',
        likes: 4,
        replies: []
      }
    ],
    reactions: {
      like: 8,
      celebrate: 2,
      support: 1,
      insightful: 12,
      curious: 6
    },
    longDescription: `
      <p>APN Virtual Investment Strategies Summit! Join us for an engaging online event featuring expert panels, interactive discussions, and virtual networking opportunities focused on investment strategies.</p>

      <p>This virtual summit brings together finance professionals and investment experts from across the country. Whether you're in investment banking, private equity, wealth management, or any other finance specialty, this is your chance to gain valuable insights from industry leaders.</p>

      <p>The event will include:</p>
      <ul>
        <li>Expert panel discussions on current investment trends</li>
        <li>Interactive Q&A sessions with industry leaders</li>
        <li>Virtual networking breakout rooms</li>
        <li>Digital resource materials for all attendees</li>
      </ul>

      <p>Don't miss this opportunity to learn and connect from the comfort of your home or office!</p>
    `,
    ticketTypes: [
      {
        id: 'member',
        name: 'Member Registration',
        price: 50.00,
        description: 'For current APN members',
        memberOnly: true
      },
      {
        id: 'non-member',
        name: 'Non-Member Registration',
        price: 75.00,
        description: 'For non-members',
        memberOnly: false
      }
    ],
    sponsors: [
      {
        id: 1,
        name: 'Goldman Sachs',
        level: 'Gold',
        attendeeLimit: 15,
        additionalAttendeeDiscount: 50
      },
      {
        id: 4,
        name: 'BlackRock',
        level: 'Silver',
        attendeeLimit: 8,
        additionalAttendeeDiscount: 25
      },
      {
        id: 5,
        name: 'Citi',
        level: 'Bronze',
        attendeeLimit: 5,
        additionalAttendeeDiscount: 15
      }
    ],
    attendees: [],
    accessDates: {
      basic: '2025-10-28T00:00:00Z', // One week before event
      bronze: '2025-10-21T00:00:00Z', // Two weeks before event
      silver: '2025-10-16T00:00:00Z', // 2.5 weeks before event
      gold: '2025-10-14T00:00:00Z'    // Three weeks before event
    },
    eventType: 'virtual',
    virtualPlatform: 'Microsoft Teams',
    virtualLink: 'https://teams.microsoft.com/l/meetup-join/example' // This would be generated closer to the event
  },
  {
    id: 5,
    title: 'APN Fall Finance Mixer',
    image: '/images/events/event-placeholder.png',
    date: 'October 14, 2025',
    time: '6:30 PM - 9:30 PM',
    location: 'The Standard Club, Chicago',
    address: '320 S Plymouth Ct, Chicago, IL 60604',
    price: '$100.00 - $150.00',
    featured: true,
    description: 'Join us for our fall networking event at The Standard Club in Chicago! Connect with finance professionals from across the Midwest and enjoy an evening of networking in this historic venue.',
    longDescription: `
      <p>APN Fall Finance Mixer! Join us for an evening of networking, connections, and opportunities at The Standard Club, one of Chicago's most prestigious venues.</p>

      <p>This exclusive event brings together finance professionals from across the Midwest. Whether you're in investment banking, private equity, wealth management, or any other finance specialty, this is your chance to expand your network and forge valuable connections.</p>

      <p>The event will include:</p>
      <ul>
        <li>Networking with finance professionals across all levels</li>
        <li>Gourmet appetizers and premium open bar</li>
        <li>Brief remarks from industry leaders</li>
        <li>Opportunities to connect with potential mentors and collaborators</li>
      </ul>

      <p>Don't miss this opportunity to be part of Chicago's premier finance networking community!</p>
    `,
    ticketTypes: [
      {
        id: 'member',
        name: 'Member Registration',
        price: 100.00,
        description: 'For current APN members',
        memberOnly: true
      },
      {
        id: 'non-member',
        name: 'Non-Member Registration',
        price: 150.00,
        description: 'For non-members',
        memberOnly: false
      }
    ],
    sponsors: [
      {
        id: 1,
        name: 'Goldman Sachs',
        level: 'Gold',
        attendeeLimit: 12,
        additionalAttendeeDiscount: 50
      },
      {
        id: 2,
        name: 'JP Morgan',
        level: 'Silver',
        attendeeLimit: 8,
        additionalAttendeeDiscount: 25
      },
      {
        id: 3,
        name: 'Bank of America',
        level: 'Bronze',
        attendeeLimit: 5,
        additionalAttendeeDiscount: 15
      }
    ],
    attendees: [],
    accessDates: {
      basic: '2025-10-07T00:00:00Z', // One week before event
      bronze: '2025-09-30T00:00:00Z', // Two weeks before event
      silver: '2025-09-25T00:00:00Z', // 2.5 weeks before event
      gold: '2025-09-23T00:00:00Z'    // Three weeks before event
    },
    eventType: 'in-person'
  }
];

// Combine past and upcoming events
const allEvents = [...events, ...pastEvents];

// Helper function to get event by ID
export const getEventById = (id) => {
  return allEvents.find(event => event.id === parseInt(id));
};

// Helper function to get upcoming events
export const getUpcomingEvents = () => {
  return events.sort((a, b) => new Date(a.date) - new Date(b.date));
};

// Helper function to get past events
export const getPastEvents = () => {
  return pastEvents.sort((a, b) => new Date(b.date) - new Date(a.date));
};
// Helper function to calculate ticket price based on membership and referral
export const calculateTicketPrice = (event, ticketType, isMember, sponsorId = null, referralCode = null) => {
  console.log('🔍 calculateTicketPrice called with:', { event: event?.title, ticketType, isMember, sponsorId, referralCode });

  if (!event || !event.ticketTypes) {
    console.error('Event or ticketTypes missing:', event);
    return 0;
  }

  const ticket = event.ticketTypes.find(t => t.id === ticketType);
  if (!ticket) {
    console.error('Ticket type not found:', ticketType, 'Available types:', event.ticketTypes.map(t => t.id));
    return 0;
  }

  console.log('🔍 Found ticket:', ticket);
  let price = ticket.price;

  // Apply member discount if applicable
  // The ticket price should already reflect member vs non-member pricing
  // Member tickets should have lower prices than non-member tickets

  // Apply referral discount (5% for all members)
  if (referralCode && referralCode.trim() && isMember) {
    const discountAmount = price * 0.05; // 5% discount
    price = price - discountAmount;
    console.log('🔍 Applied referral discount:', discountAmount, 'New price:', price);
  }

  // Apply sponsor discount if applicable
  if (sponsorId && event.sponsors) {
    const sponsor = event.sponsors.find(s => s.id === sponsorId);
    if (sponsor && sponsor.additionalAttendeeDiscount) {
      const sponsorDiscount = price * (sponsor.additionalAttendeeDiscount / 100);
      price = price - sponsorDiscount;
      console.log('🔍 Applied sponsor discount:', sponsorDiscount, 'New price:', price);
    }
  }

  const finalPrice = Math.max(0, price); // Ensure price is never negative
  console.log('🔍 Final calculated price:', finalPrice);
  return finalPrice;
};

// Helper function to export attendee list as CSV
export const exportAttendeesToCSV = (attendees, eventTitle) => {
  const headers = [
    'Name',
    'Email',
    'Company',
    'Title',
    'Ticket Type',
    'Registration Date',
    'Payment Status'
  ];

  const csvContent = [
    headers.join(','),
    ...attendees.map(attendee => [
      `"${attendee.name || ''}"`,
      `"${attendee.email || ''}"`,
      `"${attendee.company || ''}"`,
      `"${attendee.title || ''}"`,
      `"${attendee.ticketType || ''}"`,
      `"${attendee.registrationDate ? new Date(attendee.registrationDate).toLocaleDateString() : ''}"`,
      `"${attendee.paymentStatus || 'Pending'}"`
    ].join(','))
  ].join('\n');

  return csvContent;
};

